import { supabase } from '../lib/supabase';

export const trackEvent = (eventName: string, metadata?: any) => {
  const timestamp = new Date().toISOString();
  
  // 1. Log Estruturado nos DevTools (apenas em desenvolvimento)
  if (import.meta.env.DEV) {
    console.log(`[TELEMETRIA] ${eventName}`, {
      timestamp,
      metadata
    });
  }

  // 2. Persistência no Banco de Dados (Supabase) - SEM BLOQUEAR A UI (Fire and Forget)
  supabase.auth.getSession().then(({ data: { session } }) => {
    const user = session?.user;
    if (user) {
      supabase.from('activity_logs').insert({
        user_id: user.id,
        event_type: eventName,
        metadata: metadata || {}
      }).then(({ error }) => {
        if (error) console.warn('[TELEMETRIA_DB_ERROR]', error.message);
      });
    }
  }).catch((err) => {
    // Falha silenciosa para telemetria (não deve afetar o usuário)
  });

  // 3. Analytics Externo (se houver)
  if ((window as any).gtag) {
    (window as any).gtag('event', eventName, metadata);
  }
};

export const logError = (error: any, context: string, extraMetadata?: any) => {
  const ua = navigator.userAgent;
  console.error(`[ERROR_TELEMETRY] Context: ${context}`, {
    error: error?.message || error,
    stack: error?.stack,
    ua,
    url: window.location.href,
    timestamp: new Date().toISOString(),
    ...extraMetadata
  });
  
  trackEvent('erro_calculo_ou_pdf', { 
    context, 
    errorMessage: error?.message || String(error), 
    stack: error?.stack,
    ...extraMetadata 
  });
};
